export class Unidade {

  Id: number;
  Descricao: string;
  Cidade: string;
  CidadeId: number;
  NomeEscritorio: string;
  Endereco: string;
  CNPJ: string;
  Ativo: boolean;
  Rateio: boolean;
  // AcessoAOutrasUnidades: boolean;

  constructor() {
    this.Id = 0;
    this.Descricao = '';
    this.CidadeId = null;
    this.NomeEscritorio = '';
    this.Endereco = '';
    this.CNPJ = '';
    this.Ativo = true;
    this.Rateio = false;
  }
}
